import React from "react";
import {createRoot} from "react-dom/client";
import BookingInitialSearch from "./components/BookingInitialSearch";
import BookingPage from "./components/BookingPage";
import QuoteRequestPage from "./components/QuoteRequestPage";
import PaymentPage from "./components/PaymentPage";

export default () => {

  const doms = document.querySelectorAll('[data-booking-element]');
  for (const dom of doms) {
    const root = createRoot(dom);
    root.render(<BookingInitialSearch />);
  }

  const charterDoms = document.querySelectorAll('[data-charter-element]');
  for (const dom of charterDoms) {
    const root = createRoot(dom);
    root.render(<BookingInitialSearch charter={true} />);
  }

  const bookingForms = document.querySelectorAll('[data-booking-form]');
  for (const dom of bookingForms) {
    const root = createRoot(dom);
    root.render(<BookingPage />);
  }

  const quoteForms = document.querySelectorAll('[data-quote-form]');
  for (const dom of quoteForms) {
    const root = createRoot(dom);
    root.render(<QuoteRequestPage />);
  }
  const paymentForms = document.querySelectorAll('[data-payment-form]');
  for (const dom of paymentForms) {
    const root = createRoot(dom);
    root.render(<PaymentPage />);
  }
}
